import { request } from 'umi';
import type {Key, ReactText} from "react";
import type { pdfMergeParam} from "@/models/createHealthReport";
import {SearchCustomerPlan} from "@/pages/Customer/CustomerDetail/components/HealthProgram/data";

interface pageNumParams {
  customerId: string,
  sourceCode: number
  sourceId: number
}
export type generatePersonalReportType= {
  conclusion?: string
  startTime?: string
  endTime?: string
  name?: ReactText
  contents?: any[]
  medias: string
  basicInfoType: string
  focusType: string
  questionnaireNames: string
  templateId?: number
  pdfMergeParamList: pdfMergeParam[]
  idList: Key[],
  /* 1：健康报告-模板生成，2：客户详情页生成") */
  source: number,
};
export async function getPageNum(params: pageNumParams) {

  return request('/hm/pdf/getPageNum',{
    method: 'POST',
    params
  })
}
export async function getPersonTemplateDetail(params: {id: number}) {
  return request('/hm/customer-report/getPersonTemplateDetail',{
    params
  })
}
export async function generatePersonalReport(data:  generatePersonalReportType) {
  return request('/hm/customer-report/generatePersonalReport',{
    method: 'POST',
    data
  })
}
export async function addOrEditPersonTemplate(data:  {id?: number,name?: string,status?: number,templateInfo: Record<string, any>[]}) {
  return request('/hm/customer-report/addOrEditPersonTemplate',{
    method: 'POST',
    data
  })
}

/**
 *  个人报告模板
 */
export async function getPersonTemplateList() {
  return request('/hm/customer-report/getPersonTemplateList', {
    method: 'GET',
    params:{current:1,pageSize:999,status:1 },
  })
}
/**
 *
 */
export async function questionnaireType(params: {customerId: string, questionnaireType: string}) {
  return request('/hm/questionnaire/record/search/questionnaireType', {
    method: 'GET',
    params,
  })
}


export async function searchPlan(params: SearchCustomerPlan) {
  return request('/hm/plan/search', {
    params
  })
};
